import { environmentConfiguration } from '@src/config/env';

const { environments } = environmentConfiguration;

const hosts = {
    [environments.local]: [
        {
            de: 'praemienrechner-local.atuprinet.ch',
            fr: 'calculateur-de-primes-local.atuprinet.ch',
            it: 'calcolatore-dei-premi-local.atuprinet.ch',
        },
        {
            de: 'myatupri-local.atuprinet.ch',
            fr: 'myatupri-local.atuprinet.ch',
            it: 'myatupri-local.atuprinet.ch',
        },
    ],
    [environments.dev]: [
        {
            de: 'dpremiumcalculator.ocp-d.atupri.ch',
            fr: 'dcalculateur.ocp-d.atupri.ch',
            it: 'dcalcolatore.ocp-d.atupri.ch',
        },
        {
            de: 'dmyatupri.ocp-d.atupri.ch',
            fr: 'dmyatupri.ocp-d.atupri.ch',
            it: 'dmyatupri.ocp-d.atupri.ch',
        },
        {
            de: 'dmyatupri-ciam.ocp-d.atupri.ch',
            fr: 'dmyatupri-ciam.ocp-d.atupri.ch',
            it: 'dmyatupri-ciam.ocp-d.atupri.ch',
        },
    ],
    [environments.test]: [
        {
            de: 'tpremiumcalculator.ocp-t.atupri.ch',
            fr: 'tcalculateur.ocp-t.atupri.ch',
            it: 'tcalcolatore.ocp-t.atupri.ch',
        },
        {
            de: 'dmyatupri.ocp-d.atupri.ch',
            fr: 'dmyatupri.ocp-d.atupri.ch',
            it: 'dmyatupri.ocp-d.atupri.ch',
        },
        {
            de: 'tmyatupri.ocp-t.atupri.ch',
            fr: 'tmyatupri.ocp-t.atupri.ch',
            it: 'tmyatupri.ocp-t.atupri.ch',
        },
        {
            de: 'tmyatupri.atupri.ch',
            fr: 'tmyatupri.atupri.ch',
            it: 'tmyatupri.atupri.ch',
        },
        {
            de: 'dmyatupri-ciam.ocp-d.atupri.ch',
            fr: 'dmyatupri-ciam.ocp-d.atupri.ch',
            it: 'dmyatupri-ciam.ocp-d.atupri.ch',
        },
    ],
    [environments.int]: [
        {
            de: 'ipremiumcalculator.ocp-i.atupri.ch',
            fr: 'icalculateur.ocp-i.atupri.ch',
            it: 'icalcolatore.ocp-i.atupri.ch',
        },
        {
            de: 'imyatupri.ocp-i.atupri.ch',
            fr: 'imyatupri.ocp-i.atupri.ch',
            it: 'imyatupri.ocp-i.atupri.ch',
        },
        {
            de: 'imyatupri.atupri.ch',
            fr: 'imyatupri.atupri.ch',
            it: 'imyatupri.atupri.ch',
        },
    ],
    [environments.prod]: [
        {
            de: 'praemienrechner.atupri.ch',
            fr: 'calculateur-de-primes.atupri.ch',
            it: 'calcolatore-dei-premi.atupri.ch',
        },
        {
            de: 'ppremiumcalculator.ocp.atupri.ch',
            fr: 'pcalculateur.ocp.atupri.ch',
            it: 'pcalcolatore.ocp.atupri.ch',
        },
        {
            de: 'myatupri.atupri.ch',
            fr: 'myatupri.atupri.ch',
            it: 'myatupri.atupri.ch',
        },
        {
            de: 'pmyatupri.ocp.atupri.ch',
            fr: 'pmyatupri.ocp.atupri.ch',
            it: 'pmyatupri.ocp.atupri.ch',
        },
    ],
};

const languages = {
    de: 'de',
    fr: 'fr',
    it: 'it',
};

const locale_countries = {
    de: 'de-CH',
    fr: 'fr-CH',
    it: 'it-CH',
};

export const localizationConfiguration = {
    hosts,
    languages,
    locale_countries,
};
